export default {"src":"/_next/static/media/undraw_taken_re_yn20.d086cb1e.svg","height":738,"width":673,"blurWidth":0,"blurHeight":0};